import React, { useState, useMemo } from "react";
import About from "../About";
import data from "../../../../_data/about.json";

export default function ContactUs() {
  const contactUs = data?.contactUs;
  const [formData, setFormData] = useState({});

  if (!contactUs) {
    return (
      <section className="contact-us">
        <div className="contact-us-empty">Contact data not found.</div>
      </section>
    );
  }

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = formData.subject || "Inquiry from Website";
    const body = `
    Name: ${formData.fullName || ""}
    Email: ${formData.email || ""}
    Company: ${formData.company || ""}
    Reason: ${formData.reason || ""}

    Message:
    ${formData.message || ""}
      `.trim();

    const mailtoLink = `mailto:${contactUs.form.emailTo}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  return (
    <>
      <About />

      <section className="contact-us">
        {/* Left Column: Form */}
        <div className="contact-us-form-container">
          <div className="contact-us-form-col">
            <div className="contact-us-header">
              <h2 className="contact-us-title">{contactUs.form.title}</h2>
              <p className="contact-us-desc">{contactUs.form.description}</p>
              <p className="contact-us-required-text">{contactUs.form.requiredText}</p>
            </div>

            <form className="contact-us-form" onSubmit={handleSubmit}>
              <div className="form-grid">
                {(contactUs.form.fields || []).map((field, index) => (
                  <div key={index} className={`form-group field-${field.width}`}>
                    {field.type !== "textarea" && field.type !== "select" && (
                      <div className="input-wrapper">
                        <input
                          id={field.name}
                          name={field.name}
                          type={field.type}
                          required={field.required}
                          placeholder=" "
                          className="form-input"
                          onChange={handleInputChange}
                        />
                        <label htmlFor={field.name} className="form-label">
                          {field.label}
                          {field.required && " *"}
                        </label>
                      </div>
                    )}

                    {field.type === "select" && (
                      <div className="input-wrapper select-wrapper">
                        <select
                          id={field.name}
                          name={field.name}
                          required={field.required}
                          className="form-input form-select"
                          onChange={handleInputChange}
                          defaultValue=""
                        >
                          {field.options &&
                            field.options.map((opt, i) => (
                              <option key={i} value={opt.value} disabled={opt.value === ""}>
                                {opt.label}
                              </option>
                            ))}
                        </select>
                        <label htmlFor={field.name} className="form-label">
                          {field.label}
                          {field.required && " *"}
                        </label>
                      </div>
                    )}

                    {field.type === "textarea" && (
                      <div className="input-wrapper textarea-wrapper">
                        <textarea
                          id={field.name}
                          name={field.name}
                          required={field.required}
                          className="form-input form-textarea"
                          rows="4"
                          onChange={handleInputChange}
                          placeholder=" "
                        ></textarea>
                        <label htmlFor={field.name} className="form-label">
                          {field.label}
                        </label>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Checkbox */}
              {contactUs.form.checkbox && (
                <div className="form-checkbox-group">
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      required={contactUs.form.checkbox.required}
                      name="agreement"
                      onChange={handleInputChange}
                    />
                    <span className="checkmark"></span>
                    <span className="checkbox-label">{contactUs.form.checkbox.label}</span>
                  </label>
                </div>
              )}

              <button type="submit" className="form-submit-btn">
                {contactUs.form.submitLabel}
              </button>
            </form>
          </div>

          {/* Right Column: Image */}
          <div className="contact-us-image-col">
            <img
              src="/assets/img/contact_us_background.png"
              alt="Contact Us"
              className="contact-us-image"
            />
          </div>
        </div>
      </section>
    </>
  );
}
